import { type FC } from 'react';
import { Flex, type FlexProps } from '@chakra-ui/react';

const Root: FC<FlexProps> = (props) => <Flex height="100%" {...props} />;

export default Root;
